import { DetailEditEntityDialog } from '@/features/shared/components/entityDetails/DetailEditEntityDialog';
import { buildStatusOptions } from '@/shared/constants/statusOptions';
import type { BuildStatus, PipelineStageExecutionListItemDto } from '@flowqa/shared';
import type { ReactElement } from 'react';

type StageExecutionEditDialogProps = {
  open: boolean;
  execution: PipelineStageExecutionListItemDto | null;
  loading?: boolean;
  onClose: () => void;
  onSave: (input: {
    status?: BuildStatus;
    startedAt?: Date | null;
    finishedAt?: Date | null;
    durationMs?: number | null;
  }) => Promise<void> | void;
};

export const StageExecutionEditDialog = ({
  open,
  execution,
  loading = false,
  onClose,
  onSave,
}: StageExecutionEditDialogProps): ReactElement => {
  return (
    <DetailEditEntityDialog
      open={open}
      entityLabel="Stage Execution"
      entityName={execution?.stageName ?? ''}
      status={execution?.status}
      statusOptions={buildStatusOptions}
      timestamp={execution?.startedAt ?? null}
      secondaryTimestamp={execution?.finishedAt ?? null}
      timestampLabel="Started"
      secondaryTimestampLabel="Finished"
      durationMs={execution?.durationMs ?? null}
      durationLabel="Duration"
      durationInputMode="timeParts"
      loading={loading}
      onClose={onClose}
      onSave={async ({ status, timestamp, secondaryTimestamp, durationMs }) => {
        await onSave({
          status,
          startedAt: timestamp,
          finishedAt: secondaryTimestamp,
          durationMs,
        });
      }}
    />
  );
};
